import React, { PureComponent } from 'react';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';
import { StoreComponent_StoreShowPrice as ShowPrice } from 'ggApp/modules/store';

import GGOrderSingleProduct from '../SingleProduct';

import styles from './index.module.scss';

export default class Summary extends PureComponent {
    render() {
        const { order, desktopColumnItem, isDesktopUser, hideMobile } = this.props;
        const singleProduct = order.items.length === 1;
        const singleProductSubscription = singleProduct && order.items[0].minimum_term_months > 1;
        const singleProductSubscriptionDuration = order.items[0].minimum_term_months;
        return (
            <div
                className={`${styles.checkoutPlanOrderSummary} ${
                    hideMobile ? styles['checkoutPlanOrderSummary--hideMobile'] : ''
                }`}
            >
                <div className={styles.checkoutPlanOrderSummary__list}>
                    {order.items.map((product, index) => (
                        <GGOrderSingleProduct
                            // eslint-disable-next-line react/no-array-index-key
                            key={index}
                            product={product}
                            big={singleProduct}
                            desktopColumn={desktopColumnItem}
                            absolute={false}
                            withBorderBottom
                            mobile={!isDesktopUser}
                        />
                    ))}
                </div>
                {order.store_code !== 'de' && (
                    <div className={styles.checkoutPlanOrderSummary__total}>
                        <div>
                            <ShowPrice
                                price={order.item_total}
                                orderCurrencySymbol={order.currencySymbol}
                            />{' '}
                            / <span />
                            {(singleProductSubscription && (
                                <Translator
                                    withValues={{
                                        duration: singleProductSubscriptionDuration,
                                    }}
                                    tk="MONTH_FOR_N_MONTHS"
                                />
                            )) || <Translator tk="MONTH_SHORT" />}
                        </div>
                        <Translator
                            tk="TAX_APPLY"
                            className={styles.checkoutPlanOrderSummary__taxApply}
                        />
                    </div>
                )}
            </div>
        );
    }
}
